import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { AppState } from '../app';
import {DatePicker} from '@/features/reports/services';
import {DateOption} from '@/features/reports/models';
import {ReportLabels} from '@/features/reports/models';
import {FlowListOption} from '@/features/reports/models';

export interface ReportState {
	labels: { [reportId: string]: ReportLabels };
	selectedDateOption: DateOption;
	selectedFlowId: string;
	flowListOptions: FlowListOption[];
	isReportLoading: boolean;
}

// initial state
export const reportState: ReportState = {
	labels: {},
	selectedDateOption: DatePicker.options.today,
	selectedFlowId: 'all',
	flowListOptions: [],
	isReportLoading: false
};

export const reports: Module<ReportState, AppState> = {
	namespaced: false,
	state: reportState,
	actions,
	getters,
	mutations
};
